export class OperacionAnularExpedienteDto {
  Motivo: number;
  Observacion: String;
  esZonaAzul: boolean;
}
